import { useCallback, useEffect, useRef, useState } from 'react';
import Form from 'devextreme-react/form';
import 'devextreme-react/autocomplete';
import 'devextreme-react/date-range-box';
import { accountService } from '@/projects/admin/services/account-service';
import { IAccount } from '@/core/interfaces/admin/usestate-interfaces';
import { useNavigate } from 'react-router-dom';
import { ELEMENT_ID } from '@/core/constants/common/element-constants';
import FormWrapper from '@/core/wrappers/form-wrapper';
import { BUTTON_CONSTANTS } from '@/core/constants/common/button-contants';
import CustomStore from 'devextreme/data/custom_store';
import { t } from 'i18next';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';

function AccountDefinition(props: any) {
    const { accountId, onAfterSubmit } = props;
    const formRef: any = useRef<Form>();
    const [account, setAccount] = useState<IAccount>({ id: '', name: '', parentId: null, accountType: null, accountSegment: null });
    const [accountSegmentEditorOptions, setAccountSegmentEditorOptions] = useState<any>({
        inputAttr: { [ELEMENT_ID]: 'accountSegment' },
        dataSource: ["P1", "P2", "P3", "T1", "T2", "T3"],
        placeholder: undefined,
    });

    const navigate = useNavigate();
    const [title, setTitle] = useState<string>();

    useEffect(() => {
        if (accountId && account.id == '') {
            (async function () {
                const getAccount = await accountService.getAccount(accountId)
                const data = getAccount.data;
                setAccount({ id: data.id, name: data.name, parentId: data.parentId, accountType: data.accountType, accountSegment: data.accountSegment })
            })();
        }
    }, [account]);



    const [accountStore] = useState(() =>
        createCustomStore({
            key: 'id',
            load: accountService.lookupAccounts,
            byKey: (key, loadOptions) => {
                if (key) {
                    loadOptions.filter = ['id', '=', key];
                }
            },
        })
    );


    const handleSubmit = useCallback(async (): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                const accountForm = formRef.current.props.formData;
                if (accountId) {
                    await accountService.updateAccount(null, accountForm)
                } else {
                    const response = await accountService.createAccount(accountForm)
                    onAfterSubmit(response);
                }
                resolve();
            } catch (error) {
                reject(error)
            }

        })
    }, []);

    const accountNameEditorOptions = {
        inputAttr: { [ELEMENT_ID]: 'accountName' },
    };

    const parentAccountEditorOptions = {
        inputAttr: { [ELEMENT_ID]: 'parentId' },
        dataSource: accountStore,
        displayExpr: 'name',
        valueExpr: 'id',
        placeholder: undefined,
    };

    const accountTypeEditorOptions = {
        inputAttr: { [ELEMENT_ID]: 'accountType' },
        dataSource: [{
            id: "Retailer",
            name: t('retailer')
        },
        {
            id: "Supplier",
            name: t('supplier')
        }],
        displayExpr: 'name',
        valueExpr: 'id',
        placeholder: undefined,
        onValueChanged: (e: any) => {
            var dataSource = ["P1", "P2", "P3", "T1", "T2", "T3"];
            if ("Retailer" === e.value) {
                dataSource = ["P1", "P2", "P3"];
            }
            else if ("Supplier" === e.value) {
                dataSource = ["T1", "T2", "T3"];
            }

            setAccountSegmentEditorOptions({
                inputAttr: { [ELEMENT_ID]: 'accountSegment' },
                dataSource,
                placeholder: undefined,
            });
        }
    };

    const navigateBack = () => {
        navigate(-1)
    }
    return (
        <>
            <FormWrapper
                onSubmit={handleSubmit}
                formRef={formRef}
                formData={account}
                backButtonNavigationPath='/admin/account-list'
                onContinue={onAfterSubmit}
                isAddBackBtn={true}
                buttonGroups=
                {[
                    { buttonOptions: BUTTON_CONSTANTS.SaveBtn }
                ]}
                simpleItemGroups={[
                    {
                        caption: account.id == '' ? t('new_account') : t('edit_account'),
                        useColCountByScreen: true,
                        items: [
                            {
                                dataField: 'name',
                                editorType: 'dxTextBox',
                                editorOptions: accountNameEditorOptions,
                                label: 'account_name',
                                isRequired: true,
                                requiredMessage: 'account_name_required'

                            },
                            {
                                dataField: 'parentId',
                                editorType: 'dxSelectBox',
                                editorOptions: parentAccountEditorOptions,
                                label: 'parent_account',
                            },
                            {
                                dataField: 'accountType',
                                editorType: 'dxSelectBox',
                                editorOptions: accountTypeEditorOptions,
                                label: 'account_type',
                            },
                            {
                                dataField: 'accountSegment',
                                editorType: 'dxSelectBox',
                                editorOptions: accountSegmentEditorOptions,
                                label: 'Segment',
                            }
                        ],

                    }
                ]}
            />
        </>
    );
}
export default AccountDefinition;